import { render, staticRenderFns } from "./ResultsCount.vue?vue&type=template&id=123ffef0&scoped=true&"
import script from "./ResultsCount.vue?vue&type=script&lang=js&"
export * from "./ResultsCount.vue?vue&type=script&lang=js&"
import style0 from "./ResultsCount.vue?vue&type=style&index=0&id=123ffef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123ffef0",
  null
  
)

export default component.exports